import { render, staticRenderFns } from "./limitSalesAction.vue?vue&type=template&id=dbc36cd4&scoped=true"
import script from "./limitSalesAction.vue?vue&type=script&lang=js"
export * from "./limitSalesAction.vue?vue&type=script&lang=js"
import style0 from "./limitSalesAction.vue?vue&type=style&index=0&id=dbc36cd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc36cd4",
  null
  
)

export default component.exports